import { UPDATE_USER } from "@Actions/types";
import { logout } from "@Redux/Actions/authentication";
import { getChatsAndMessages } from "@Redux/Actions/chats";
import { includes } from "lodash";

const refetch = (store) => {
	return (next) => {
		return (action) => {
			const { type, payload } = action;
			const path = window.location.pathname;
			const actions = [UPDATE_USER];
			if (includes(actions, type)) {
				const { companyId } = store.getState().company;
				if (!payload.data.isActive && companyId === payload.data.companyId) {
					store.dispatch(logout({ withMessage: true, message: "Su usuario ha sido inactivado, por favor contacté a su administrador." }));
				} else if (path === "/monitor") {
					store.dispatch(getChatsAndMessages());
				} else if (path === "/chooseCompany") {
					window.location.reload();
				}
			}

			const result = next(action);
			return result;
		};
	};
};

export default refetch;
